export default "__VITE_ASSET__7e8d4017__"